function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useState, useRef, forwardRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Popper from '@material-ui/core/Popper';
import Paper from '@material-ui/core/Paper';
import DropDownIcon from '@material-ui/icons/ArrowDropDown';
import MenuList from '@material-ui/core/MenuList';
import MenuItem from '@material-ui/core/MenuItem';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import Button from '@material-ui/core/Button';
import ButtonBase from '@material-ui/core/ButtonBase';
import EditIcon from '@material-ui/icons/Edit';
import ViewIcon from '@material-ui/icons/RemoveRedEye';
import NavAction from "../NavAction/NavAction";
const useStyles = makeStyles(theme => ({
  root: {
    fontSize: "14px",
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1)
  },
  label: {
    fontFamily: "Akkurat, sans-serif",
    fontSize: "inherit",
    fontWeight: "bold",
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2)
  },
  primaryButton: {
    borderRadius: 0,
    minWidth: theme.spacing(7),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    height: theme.spacing(5),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: "bold"
  },
  primaryToggle: {
    borderRadius: 0,
    width: theme.spacing(5),
    height: theme.spacing(5)
  },
  iconButton: {
    fontSize: "inherit",
    minWidth: theme.spacing(5),
    minHeight: theme.spacing(5),
    border: "1px solid",
    borderColor: "rgba(0,0,0,.25)",
    [theme.breakpoints.down('xs')]: {
      border: "none"
    }
  },
  icon: {
    fontSize: "18px"
  }
}));

const PrimaryButton = ({
  disabled,
  label,
  onClick
}) => {
  const classes = useStyles();
  return React.createElement(Button, {
    variant: "contained",
    color: "primary",
    className: classes.primaryButton,
    disabled: disabled,
    onClick: onClick
  }, label);
};

const PrimaryComboButton = ({
  forwardedRef,
  disabled,
  expanded,
  controls,
  label,
  onClick,
  onToggle
}) => {
  const classes = useStyles();
  return React.createElement(ButtonGroup, {
    "aria-label": "action",
    color: "primary",
    ref: forwardedRef
  }, React.createElement(Button, {
    variant: "contained",
    className: classes.primaryButton,
    disabled: disabled,
    onClick: onClick
  }, label), React.createElement(Button, {
    variant: "contained",
    className: classes.primaryToggle,
    size: "small",
    "aria-controls": expanded ? controls : undefined,
    "aria-expanded": expanded ? 'true' : undefined,
    "aria-label": "options",
    "aria-haspopup": "menu",
    onClick: onToggle
  }, React.createElement(DropDownIcon, null)));
};

const PrimaryIconButton = ({
  onClick,
  children
}) => {
  const classes = useStyles();
  return React.createElement(ButtonBase, {
    className: classes.iconButton,
    onClick: onClick
  }, children);
};

const EditorAction = ({
  className,
  primaryAction
}) => {
  const _useState = useState(false),
        expanded = _useState[0],
        setExpanded = _useState[1];

  const anchorRef = useRef(null);
  const classes = useStyles();

  if (!primaryAction) {
    return false;
  }

  const handleToggle = event => {
    setExpanded(prevExpanded => !prevExpanded);
  };

  const handleSelect = ({
    onClick
  }) => {
    onClick && onClick();
    setExpanded(false);
  }; //    const primaryAction = action && action[0]


  if (primaryAction && primaryAction.type === "view") {
    return React.createElement("nav", {
      className: className || classes.root
    }, React.createElement(PrimaryIconButton, primaryAction, React.createElement(ViewIcon, {
      className: classes.icon
    })));
  } else if (primaryAction && primaryAction.type === "edit") {
    return React.createElement("nav", {
      className: className || classes.root
    }, React.createElement(PrimaryIconButton, primaryAction, React.createElement(EditIcon, {
      className: classes.icon
    })));
  } // navAcswtion


  if (primaryAction) {
    return React.createElement(NavAction, {
      className: className || classes.root,
      primaryAction: primaryAction,
      placement: "bottom-end"
    });
  }

  if (primaryAction && primaryAction.children) {
    return React.createElement("nav", {
      className: className || classes.root
    }, React.createElement(PrimaryComboButton, _extends({}, primaryAction, {
      expanded: expanded,
      forwardedRef: anchorRef,
      onToggle: handleToggle
    })), React.createElement(Popper, {
      open: expanded,
      style: {
        zIndex: 2000
      },
      role: undefined,
      transition: true,
      anchorEl: anchorRef.current,
      placement: "bottom-start"
    }, React.createElement(ClickAwayListener, {
      onClickAway: handleToggle
    }, React.createElement("div", null, React.createElement(Paper, {
      elevation: 1,
      square: true,
      "aria-expanded": expanded
    }, React.createElement(MenuList, null, primaryAction.children.map((item, index) => React.createElement(MenuItem, _extends({}, item, {
      key: index,
      onClick: () => handleSelect(item)
    }), item.label || item.title))))))));
  }

  if (primaryAction) {
    return React.createElement("nav", {
      className: className || classes.root
    }, React.createElement(PrimaryButton, primaryAction));
  }
};

export default EditorAction;